import {TokenService as Service} from '../TokenService';

import {useDialogCrup} from '../../../../shared/hooks/DialogCrup';

export const Crup = ({header, dataKey, refreshLazyData}) => {

  const {render, create, update, setValue} = useDialogCrup({
    header,
    dataKey,
    width: '60rem',
    fields: [
      {field: 'vender', header: 'Đơn vị cấp chứng thư', type: 'InputTextarea', disabled: true, className: 'md:col-12'},
      {field: 'subjectName', header: 'Tên chủ sở hữu', type: 'InputTextarea', disabled: true, className: 'md:col-12'},
      {field: 'serialNumber', header: 'Serial chứng thư', disabled: true, className: 'md:col-12'},
      {field: 'dateFrom', header: 'Ngày có hiệu lực', type: 'Calendar', disabled: true, className: 'md:col-6'},
      {field: 'expireDate', header: 'Ngày hết hạn', type: 'Calendar', disabled: true, className: 'md:col-6'},
      {field: 'form', header: 'Hình thức', type: 'Dropdown', DropdownProps: {options: Service.forms}, disabled: true, className: 'md:col-6'},
      {field: 'tokenType', header: 'Loại chứng thư số', type: 'Dropdown', DropdownProps: {options: Service.tokenTypes}, disabled: true, className: 'md:col-6'},
      {field: 'used', header: 'Sử dụng', type: 'Checkbox', className: 'md:col-6'},
      {field: 'defaultSign', header: 'Mặc định ký', type: 'Checkbox', className: 'md:col-6'}
    ],
    defaultValue: {
      used: true
    },
    createItem: (item) => {
      return Service.create(item);
    },
    updateItem: (id, item) => {
      return Service.update(id, item);
    },
    refreshLazyData
  });

  return {render, create, update, setValue};

}